<template>
    <div class="p-6" v-if="active == name">
        <slot />
    </div>
</template>

<script>
export default {
    props: {
        name: String,
        active: String
    }
}
</script>



// WEBPACK FOOTER //
// src/components/tabs/Content.vue